module.exports = __webpack_public_path__ + "static/media/vishwanathan_home_banner.7277414a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/vishwanathan_home_banner.png
// module id = 1195
// module chunks = 0